/* eslint-disable @typescript-eslint/no-explicit-any */
import { WidgetSlot as WidgetSlotComponent } from 'component-library/Widget/WidgetSlot';

import { WidgetSlot, WidgetSlotConfiguration } from '@/api/rest/resources/types/widget';
import { isNullish } from '@/utils/booleans';

// eslint-disable-next-line import/no-cycle
import { Widget } from './Widget';

type NestedWidgetType = WidgetSlotConfiguration | WidgetSlot | null;

type WidgetSlotRendererProps = {
  nestedWidget?: NestedWidgetType;
};

const resolveDataPath = (path: string, widget: any): any[] => {
  return path.split('.').reduce((obj, key) => obj?.[`${key}`], widget) || [];
};

export const WidgetSlotRenderer = ({ nestedWidget }: WidgetSlotRendererProps) => {
  if (isNullish(nestedWidget)) {
    return null;
  }

  const isWidgetSlot = (slot: NestedWidgetType): slot is WidgetSlot => !isNullish((slot as WidgetSlot).visible);

  const handleRepeatedWidget = (widget: WidgetSlot): WidgetSlot[] => {
    if (!widget.repeat?.template?.type) return [widget];

    const data = resolveDataPath(widget.repeat.data, widget);

    if (!Array.isArray(data)) {
      return [widget];
    }

    return data.map(
      (item: any): WidgetSlot => ({
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        name: `${widget.name}_${item[widget.repeat!.key]}`,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        type: widget.repeat!.template.type,
        visible: true,
        relatedData: {
          ...item,
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          ...widget.repeat!.template.relatedData,
        },
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        widgets: widget.repeat!.template.widgets,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        repeat: widget.repeat!.template.repeat,
      }),
    );
  };
  const childrenWidgets = nestedWidget.widgets
    ?.flatMap((slot: NestedWidgetType) => {
      if (isWidgetSlot(slot) && slot.repeat) {
        return handleRepeatedWidget(slot);
      }
      return slot;
    })
    .map((slot: NestedWidgetType, index) => <WidgetSlotRenderer key={`${slot?.name}-${index}`} nestedWidget={slot} />);

  const isSlot = isWidgetSlot(nestedWidget);
  if (isSlot) {
    return (
      <WidgetSlotComponent visible={nestedWidget.visible}>
        <Widget
          key={nestedWidget.name}
          name={nestedWidget.name}
          type={nestedWidget.type}
          relatedData={nestedWidget.relatedData}
        >
          {childrenWidgets}
        </Widget>
      </WidgetSlotComponent>
    );
  }

  return <>{childrenWidgets}</>;
};
